<template>
    <div class="w-100 px-2" :style="{'text-align': align}">
        {{ params.valueFormatted }}
        <div v-if="shouldBeValidatedOnPriceExcess && linePriceExcessLevelModel" class="d-inline-block">
            <v-popover trigger="hover"
                       openGroup="ag-grid-price"
                       popoverInnerClass="popover-black">
                <span class="price-alert-icon" :class="linePriceExcessLevelModel.classes.text">
                    <i :class="linePriceExcessLevelModel.icon"></i>
                </span>
                <template v-slot:popover>
                    This price is {{ linePriceExcessPercentage }}%
                    higher than your inventory price of {{ line.sku }}
                </template>
            </v-popover>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import {FieldRendererAlign} from '@/types/document-viewer/field/modules/renderer'
import {getLinePriceExcessLevelByPercentage, getLinePriceExcessPercentage} from '@/utils/document'
import {priceAlertLevelsList} from '@/types/document/price-alerts'

export default Vue.extend({
    name: 'AgGridCellRendererPrice',
    computed: {
        ...mapGetters(['priceAlerts']),
        ...mapGetters('doc_viewer', [
            'lines',
            'priceAlertPropertyName'
        ]),

        field() {
            return this.params.settings || {}
        },

        renderer() {
            return this.field.renderer || {}
        },

        align() {
            return this.renderer.align || FieldRendererAlign.RIGHT
        },

        lineIdx() {
            return this.params.data ? this.params.data.lineIdx : -1
        },

        line() {
            return this.lines[this.lineIdx] || {}
        },

        shouldBeValidatedOnPriceExcess() {
            return this.params.colDef.fieldName === this.priceAlertPropertyName
        },

        linePriceExcessPercentage() {
            return getLinePriceExcessPercentage({line: this.line, priceProperty: this.priceAlertPropertyName})
        },

        linePriceExcessLevelKey() {
            return getLinePriceExcessLevelByPercentage({
                percentage: this.linePriceExcessPercentage,
                levels: this.priceAlerts
            })
        },

        linePriceExcessLevelModel() {
            return priceAlertLevelsList.find(l => l.key === this.linePriceExcessLevelKey)
        }
    }
})
</script>

<style lang="scss" scoped>
.price-alert-icon {
    background: white;
    padding: 4px;
    border-radius: 4px;
    margin-left: 2px;
}
</style>
